"use client"
import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
    return (
        <div className="relative overflow-hidden">
            <Content />
            <FuzzyOverlay />
        </div>
    );
};

const FuzzyOverlay = () => {
    return (
        <motion.div
            initial={{ transform: "translateX(-10%) translateY(-10%)" }}
            animate={{
                transform: "translateX(10%) translateY(10%)",
            }}
            transition={{
                repeat: Infinity,
                duration: 0.2,
                ease: "linear",
                repeatType: "mirror",
            }}
            style={{
                backgroundImage: 'url("/pettern/black-noise.png")',
            }}
            className="pointer-events-none absolute -inset-[100%] opacity-[15%]"
        />
    );
};

const Content = () => {
    return (<>
        <Helmet>
            <title>SURYA • NOt Found</title>
            <meta name="description" content="" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Helmet>
        <div className="relative grid h-screen place-content-center space-y-6 bg-smoke p-8">
            <p className="text-center text-[10rem] md:text-[16rem] font-black text-neutral-200 font-nebulica">
                4<span className="text-lemone">0</span>4
            </p>
            <p className="text-center text-neutral-300 text-wrap font-ibm text-base lg:text-2xl">
                THE PAGE YOU WERE LOOKING FOR DOESN`T EXIST.<br />
                YOU MAY HAVE MISTYPED THE ADDRESS OR THE PAGE MAY HAVE MOVED.
            </p>
            <div className="flex items-center justify-center gap-3">
                <a href="/" className='py-2 px-4 text-smoke transition-colors hover:bg-neutral-50 bg-lemone mt-3 md:mt-5 text-base md:text-lg lg:text-[1.35rem]'>Return Back</a>
            </div>
        </div>
    </>
    );
};

export default NotFound;